module.exports = __webpack_public_path__ + "img/keen_model_3.315d1177.png";